import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import {
  LATE_CANCEL_PROTECTION_PERIOD_IN_HOURS,
  LATE_CANCEL_PROTECTION_SHIFT_PAYOUT_IN_HOURS,
} from "@src/appV2/redesign/Tiers/utils/constants";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import pluralize from "pluralize";
import { useEffect } from "react";

import { useShiftModalsDataContext } from "../../ShiftDiscovery/useShiftModalsDataContext";
import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

export function ShiftLateCancelProtectionCard() {
  const { shiftId } = useShiftModalsDataContext();
  const { userId: workerId } = useDefinedWorker();

  useEffect(() => {
    logEvent(APP_V2_USER_EVENTS.VIEWED_LATE_CANCEL_PROTECTION_CARD, {
      metadata: { shiftId, workerId },
    });
  }, [shiftId, workerId]);

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="success"
      title="As a Gold member, all shifts you book have Late Cancel Protection"
      description={`You are guaranteed ${LATE_CANCEL_PROTECTION_SHIFT_PAYOUT_IN_HOURS} ${pluralize(
        "hour",
        LATE_CANCEL_PROTECTION_SHIFT_PAYOUT_IN_HOURS
      )} of pay if a workplace cancels within ${LATE_CANCEL_PROTECTION_PERIOD_IN_HOURS} ${pluralize(
        "hour",
        LATE_CANCEL_PROTECTION_PERIOD_IN_HOURS
      )} of shift start`}
      illustrationType="check-in-shield-with-diamond"
    />
  );
}
